<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_sc.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_xmsc.png'
import list_img1 from '../../images/download/down-sc1.png'
import list_img2 from '../../images/download/down-sc2.png'
import list_img3 from '../../images/download/down-sc3.png'
import cut_img1 from '../../images/download/cut_sc1.png'
import cut_img2 from '../../images/download/cut_sc2.png'
import cut_img3 from '../../images/download/cut_sc3.png'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'熊猫四川麻将',
                size:'151.3',
                load_count:'9153',
                desp:'四川麻将血战到底是成都及周边乃至整个四川盛行的麻将玩法。核心是打缺门，刮风下雨，计番，流局查大叫。一局牌中，一家胡牌并不结束牌局，而是未胡牌的玩家继续打，直到3家胡牌或剩余的玩家流局，牌局结束一并结算。这样先胡的玩家并不一定获利最多，点炮的玩家也能翻身，提高了趣味性，以及做大牌的积极性。',
                ios_url:'http://app1.xlsymj.com/?downloadfrom=sichuan',
                android_url:'http://app1.xlsymj.com/?downloadfrom=sichuan',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
